import PropTypes from 'prop-types';
import React from 'react';
import PDF from '../../common/pdf/pdf';
const PDFViewer = _ref => {
  let _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    url = _ref.url,
    height = _ref.height;
  return /*#__PURE__*/React.createElement(PDF, {
    src: url,
    title: label,
    containerMaxHeight: height,
    hideTitleIfMobile: true,
    nativeRenderer: true
  });
};
PDFViewer.propTypes = {
  label: PropTypes.string,
  url: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired
};
export default PDFViewer;